/**
 * Named, one-click theme presets for the customer app's remote theme.
 *
 * "Bharat Pink" mirrors the app's original hardcoded brand (customer_app
 * src/theme/brand.ts PINK); "Light Golden" mirrors its current GOLDEN
 * preset with warmer text/border tones tuned for an 8-field palette (the
 * code-level brand.ts only defines primary/secondary/accent/background).
 * Applying a preset is what makes "single click, whole app" literally true —
 * it fills every field the app can theme, then Save publishes it.
 */
export const THEME_PRESETS = [
  {
    id: "bharatPink",
    label: "Bharat Pink (Original)",
    swatch: "#E91E63",
    palette: {
      primary: "#E91E63",
      secondary: "#F44369",
      accent: "#FF6B81",
      background: "#FFF7F8",
      surface: "#FFFFFF",
      textPrimary: "#1F2937",
      textSecondary: "#6B7280",
      border: "#E5E7EB",
    },
    fontFamily: null,
  },
  {
    id: "lightGolden",
    label: "Light Golden",
    swatch: "#C1922E",
    palette: {
      primary: "#C1922E",
      secondary: "#D8AC55",
      accent: "#EFDCA6",
      background: "#FCF9F0",
      surface: "#FFFFFF",
      textPrimary: "#2A2110",
      textSecondary: "#7A6A4E",
      border: "#EFE6D2",
    },
    fontFamily: null,
  },
];

export const PALETTE_FIELDS = [
  { key: "primary", label: "Primary" },
  { key: "secondary", label: "Secondary" },
  { key: "accent", label: "Accent" },
  { key: "background", label: "Background" },
  { key: "surface", label: "Surface (cards)" },
  { key: "textPrimary", label: "Text — Primary" },
  { key: "textSecondary", label: "Text — Secondary" },
  { key: "border", label: "Border" },
];

export const FONT_FAMILY_LABELS = {
  SYSTEM: "System default",
  SERIF: "Serif",
  MONOSPACE: "Monospace",
  ROUNDED: "Rounded (friendly)",
};
